// LICENSE_CODE ZON
'use strict'; /*jslint node:true browser:true es9:true*/
(function(){
const is_node = typeof module=='object' && !!module.exports;
const define = !is_node ? self.define
    : require('../../../util/require_node.js').define(module, '../');
define(['/svc/account/pub/address_schema.js', 'lodash4'],
    (address_schema, _)=>
{
const E = {};

E.hidden_countries = {
    AQ: 1,
    CU: 1,
    EU: 1,
    IQ: 1,
    IR: 1,
    KP: 1,
    LB: 1,
    PS: 1,
    SD: 1,
    SY: 1,
};

E.resi_hidden_countries = {BD: 1};

E.allowed_countries = _.omit(address_schema.countries,
    Object.keys(E.hidden_countries));

E.allowed_resi_countries = _.omit(E.allowed_countries,
    Object.keys(E.resi_hidden_countries));

E.is_hidden_country = function(c){
    return !!E.hidden_countries[c];
};

E.is_resi_hidden_country = function(c){
    return !!E.resi_hidden_countries[c] || E.is_hidden(c);
};

return E; }); }()); // eslint-disable-line
